import { BILLING } from "./action";

const initialState = {
  isFetchingComplete: true,
  isError: false,
  subscriptionData: {}
};

export function billingReducer(state = initialState, action) {
    switch (action.type) {
      case BILLING.getBillingDetail.success:
        return Object.assign({}, state, {
          BillingDetails: action.data
        });
        case BILLING.upgradePlan.start:
          return {
            ...state,
            isFetchingComplete: false,
            isError: false,
            error: []
          };
        case BILLING.upgradePlan.success:
          return {
            ...state,
            isFetchingComplete: true,
            isError: false,
            subscriptionData: action.data,
            error: []
          };
        case BILLING.upgradePlan.error:
          return {
            ...state,
            isFetchingComplete: true,
            isError: true,
            error: action.data
          };
      
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/modules/billing/reducer.js